import {I$WWrapper, IWidgetController} from '@wix/native-components-infra/dist/src/types/types';
import {ControllerParams} from '@wix/yoshi-flow-editor';
import {CartIconController} from './Controller/CartIconController';
import {SPECS} from '../../constants';

type AbstractConstructorHelper<T> = (new (...args: any) => {[x: string]: any}) & T;
type AbstractConstructorParameters<T> = ConstructorParameters<AbstractConstructorHelper<T>>;
export type ControllerConstructorType<T> = new (...args: AbstractConstructorParameters<CartIconController>) => T;

export const controllerFactory =
  <T extends CartIconController>(ControllerConstructor: ControllerConstructorType<T>) =>
  (controllerParams: ControllerParams): IWidgetController => {
    const siteStore = controllerParams?.appData?.context.siteStore;
    let controller: T | undefined;

    const getController = async () => {
      if (controller) {
        return controller;
      }
      if (
        !controllerParams.controllerConfig.essentials.experiments.enabled(SPECS.StopCallingGetClientConfigInCartIcon)
      ) {
        await siteStore.loadClientConfig();
      }
      controller = new ControllerConstructor(controllerParams);
      return controller;
    };

    return {
      async pageReady() {
        try {
          const controller = await getController();

          await controller.init();
          controllerParams.controllerConfig.wixCodeApi.location.onChange(() => void controller.load());
        } catch (error) {
          /* istanbul ignore next */
          console.error(error);
          /* istanbul ignore next */
          controllerParams.controllerConfig.setProps({generalError: true});
          /* istanbul ignore next */
          controllerParams.appData?.reportError(error);
        }
      },
      exports() {
        return getExportsAfterControllerLoaded(getController, ['addToCart', 'addProductsToCart']);
      },
      updateConfig: (_$w, updatedConfig: {[key: string]: any}): void => {
        return void controller?.onStyleUpdate?.(updatedConfig.style.styleParams);
      },
      updateAppSettings: (_$w: I$WWrapper, updates: {[key: string]: any}): void => {
        return void controller?.onAppSettingsUpdate?.(updates);
      },
      onBeforeUnLoad() {
        return controller?.onBeforeUnLoad?.();
      },
    };
  };

function getExportsAfterControllerLoaded(getController: () => Promise<CartIconController>, keys: string[]) {
  return keys.reduce((acc, key) => {
    acc[key] = async (...args: any[]) => {
      const controller = await getController();
      return controller.exports()[key](...args);
    };
    return acc;
  }, {});
}
